import { IDEA_STATUSES } from '@cult/domain';
import type { IdeaStatus } from '@cult/schemas';
import { Flex, Input, Modal, Typography } from 'antd';
import { STATUS_ACTION_LABEL } from '../../hooks/use-idea-transition';

const { Text } = Typography;

type Props = {
  target: IdeaStatus | null;
  note: string;
  onNoteChange: (value: string) => void;
  onOk: () => void;
  onCancel: () => void;
  confirmLoading: boolean;
};

export const TransitionConfirmModal = ({ target, note, onNoteChange, onOk, onCancel, confirmLoading }: Props) => {
  // Closing takes no reason — the author is emailed a standard close notice instead.
  const isClosing = target === IDEA_STATUSES.CLOSED;

  return (
    <Modal
      open={target !== null}
      title={target ? `Confirm: ${STATUS_ACTION_LABEL[target]}` : ''}
      onOk={onOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      okText={target ? STATUS_ACTION_LABEL[target] : 'Confirm'}
      okButtonProps={{ danger: isClosing }}
    >
      {isClosing ? (
        <Text type="secondary" style={{ display: 'block', marginBottom: 22 }}>
          The author will automatically get an email saying the idea was closed, with the standard list of reasons.
        </Text>
      ) : (
        <Flex vertical gap={8}>
          <Text type="secondary">Optional note for the audit log.</Text>
          <Input.TextArea
            rows={4}
            value={note}
            onChange={(e) => onNoteChange(e.target.value)}
            maxLength={2000}
            showCount
            placeholder="Why is this happening? (optional)"
            style={{ marginBottom: 22 }}
          />
        </Flex>
      )}
    </Modal>
  );
};
